// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Business-page-Bg1S4 {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Business-wrap-BtWIr {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.Business-sec-aduQk {
  padding: 56px 0;
}

.Business-alt-ZQnd7 {
  background: #f7f8f9;
}

.Business-h2-cNJ5L {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 8px;
}

.Business-h2Left-m3am2 {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

.Business-lead-hULTs {
  text-align: center;
  color: var(--muted);
  font-size: 17px;
  margin: 0 auto 34px;
  max-width: 620px;
  line-height: 1.55;
}

/* Value cards */

.Business-grid-zcxk5 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.Business-card-aEFCS {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 22px;
  background: #fff;
}

.Business-cardIc-iEcIH {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  margin-bottom: 14px;
}

.Business-cardIc-iEcIH svg {
  width: 26px;
  height: 26px;
}

.Business-cardTitle-V4ygt {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 8px;
}

.Business-cardText-MPcxk {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Use-case cards */

.Business-useGrid-cA7mv {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.Business-useCard-FpBs2 {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 24px 22px;
  background: #fff;
}

.Business-useTitle-h8kbb {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 8px;
  color: var(--red);
}

.Business-useText-URN2e {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Contact card */

.Business-contactCard-JG6Kb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 28px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 32px 34px;
  background: #e4f6f3;
}

.Business-contactText-SUlhh {
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
  max-width: 560px;
}

.Business-contactActions-tx3fR {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.Business-contactBtn-ytG4B {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.Business-contactBtn-ytG4B:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.Business-contactBtnAlt-rUW6k {
  color: var(--ink);
  font-weight: 700;
  text-decoration: none;
  font-size: 14px;
}

.Business-contactBtnAlt-rUW6k:hover {
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .Business-grid-zcxk5,
  .Business-useGrid-cA7mv {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 680px) {
  .Business-sec-aduQk {
    padding: 44px 0;
  }
  .Business-grid-zcxk5,
  .Business-useGrid-cA7mv {
    grid-template-columns: 1fr;
  }
  .Business-contactCard-JG6Kb {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
    text-align: left;
  }
  .Business-contactActions-tx3fR {
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
}

@media (prefers-color-scheme: dark) {
  .Business-page-Bg1S4 {
    background: #14171a;
    color: #f3f4f6;
  }
  .Business-alt-ZQnd7 {
    background: #1a1e22;
  }
  .Business-h2-cNJ5L,
  .Business-h2Left-m3am2,
  .Business-cardTitle-V4ygt,
  .Business-contactBtnAlt-rUW6k {
    color: #f3f4f6;
  }
  .Business-lead-hULTs,
  .Business-cardText-MPcxk,
  .Business-useText-URN2e,
  .Business-contactText-SUlhh {
    color: #9aa3ad;
  }
  .Business-card-aEFCS,
  .Business-useCard-FpBs2 {
    background: #1d2125;
    border-color: #2c3137;
  }
  .Business-cardIc-iEcIH {
    background: rgba(232, 35, 43, 0.14);
  }
  .Business-contactCard-JG6Kb {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/business/Business.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;;AACjB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 8px;\n}\n.h2Left {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.lead {\n  text-align: center;\n  color: var(--muted);\n  font-size: 17px;\n  margin: 0 auto 34px;\n  max-width: 620px;\n  line-height: 1.55;\n}\n\n/* Value cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 22px;\n  background: #fff;\n}\n.cardIc {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.cardIc svg {\n  width: 26px;\n  height: 26px;\n}\n.cardTitle {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.cardText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Use-case cards */\n.useGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n}\n.useCard {\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 24px 22px;\n  background: #fff;\n}\n.useTitle {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  color: var(--red);\n}\n.useText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Contact card */\n.contactCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  flex-wrap: wrap;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 32px 34px;\n  background: #e4f6f3;\n}\n.contactText {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0;\n  max-width: 560px;\n}\n.contactActions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n.contactBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.16s, transform 0.16s;\n}\n.contactBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n.contactBtnAlt {\n  color: var(--ink);\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 14px;\n}\n.contactBtnAlt:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 1000px) {\n  .grid,\n  .useGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .grid,\n  .useGrid {\n    grid-template-columns: 1fr;\n  }\n  .contactCard {\n    flex-direction: column;\n    align-items: stretch;\n    text-align: left;\n  }\n  .contactActions {\n    align-items: stretch;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .h2Left,\n  .cardTitle,\n  .contactBtnAlt {\n    color: #f3f4f6;\n  }\n  .lead,\n  .cardText,\n  .useText,\n  .contactText {\n    color: #9aa3ad;\n  }\n  .card,\n  .useCard {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .cardIc {\n    background: rgba(232, 35, 43, 0.14);\n  }\n  .contactCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Business-page-Bg1S4`,
	"wrap": `Business-wrap-BtWIr`,
	"sec": `Business-sec-aduQk`,
	"alt": `Business-alt-ZQnd7`,
	"h2": `Business-h2-cNJ5L`,
	"h2Left": `Business-h2Left-m3am2`,
	"lead": `Business-lead-hULTs`,
	"grid": `Business-grid-zcxk5`,
	"card": `Business-card-aEFCS`,
	"cardIc": `Business-cardIc-iEcIH`,
	"cardTitle": `Business-cardTitle-V4ygt`,
	"cardText": `Business-cardText-MPcxk`,
	"useGrid": `Business-useGrid-cA7mv`,
	"useCard": `Business-useCard-FpBs2`,
	"useTitle": `Business-useTitle-h8kbb`,
	"useText": `Business-useText-URN2e`,
	"contactCard": `Business-contactCard-JG6Kb`,
	"contactText": `Business-contactText-SUlhh`,
	"contactActions": `Business-contactActions-tx3fR`,
	"contactBtn": `Business-contactBtn-ytG4B`,
	"contactBtnAlt": `Business-contactBtnAlt-rUW6k`
};
module.exports = ___CSS_LOADER_EXPORT___;
